var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.041,
    height: 126.17,
    viewBox: "0 0 391.041 126.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36562",
    "data-name": "Trac\\xE9 36562",
    d: "M0,0,374.453.136c9.052,0,7.056,0,16.588,0l-.016,126.029s-168.664-5.28-266.42-36.822S0,0,0,0Z",
    fill: "rgba(206,169,90,0.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.6428d138253342ae400a845007708a16.svg";
export { ForwardRef as ReactComponent };